export function scheduleSpaReadyAfterPaint() {
  if (typeof window === 'undefined') return () => {};

  let cleanupIdleId: number | null = null;
  let cleanupTimeoutId: number | null = null;

  const removeById = (id: string) => {
    try {
      document.getElementById(id)?.remove();
    } catch {}
  };

  const markVisualReady = () => {
    try {
      document.documentElement.classList.add('spa-ready');
    } catch {}

    removeById('human-loader');
  };

  const cleanupPrerenderShell = () => {
    removeById('prerender-shell');
  };

  markVisualReady();

  if (typeof window.requestIdleCallback === 'function') {
    cleanupIdleId = window.requestIdleCallback(cleanupPrerenderShell, {
      timeout: 3500,
    });
  } else {
    cleanupTimeoutId = window.setTimeout(cleanupPrerenderShell, 3500);
  }

  return () => {
    if (
      cleanupIdleId != null &&
      typeof window.cancelIdleCallback === 'function'
    ) {
      window.cancelIdleCallback(cleanupIdleId);
    }

    if (cleanupTimeoutId != null) {
      window.clearTimeout(cleanupTimeoutId);
    }
  };
}
